/** Shared policy list table header — PaceHRM design-system tokens. */
export default function PolicyListTableHeader({
  ruleColumnLabel,
  reminderColumnLabel = "Reminder",
}) {
  return (
    <thead className="sticky top-0 z-10 border-b border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-muted))]">
      <tr>
        <th className="w-12 px-4 py-3 font-semibold text-[hsl(var(--ds-fg))]">#</th>
        <th className="px-4 py-3 font-semibold text-[hsl(var(--ds-fg))]">Policy Name</th>
        <th className="w-16 px-4 py-3 text-center font-semibold text-[hsl(var(--ds-fg))]">Ver.</th>
        <th className="px-4 py-3 font-semibold text-[hsl(var(--ds-fg))]">{ruleColumnLabel}</th>
        <th className="px-4 py-3 font-semibold text-[hsl(var(--ds-fg))]">{reminderColumnLabel}</th>
        <th className="px-4 py-3 font-semibold text-[hsl(var(--ds-fg))]">Approval</th>
        <th className="px-4 py-3 text-center font-semibold text-[hsl(var(--ds-fg))]">
          Approval Levels
        </th>
        <th className="px-4 py-3 font-semibold text-[hsl(var(--ds-fg))]">Auto Letter</th>
        <th className="w-24 px-4 py-3 text-center font-semibold text-[hsl(var(--ds-fg))]">
          Applied Masters
        </th>
        <th className="px-4 py-3 font-semibold text-[hsl(var(--ds-fg))]">Status</th>
        <th className="px-4 py-3 font-semibold text-[hsl(var(--ds-fg))]">Actions</th>
      </tr>
    </thead>
  );
}

export const policyListRowActionClass =
  "inline-flex items-center justify-center rounded-md border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] p-1.5 text-[hsl(var(--ds-fg))] hover:bg-[hsl(var(--ds-muted))]";

export const policyListStatusClass = (active) =>
  `inline-flex rounded-md border px-2 py-0.5 text-xs font-medium ${
    active
      ? "border-[hsl(var(--ds-success)/0.35)] bg-[hsl(var(--ds-success)/0.12)] text-[hsl(var(--ds-success))]"
      : "border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-muted))] text-[hsl(var(--ds-muted-fg))]"
  }`;
